
import { GET_TERADICI_PRODUCT_ID } from "@constants/end-points";
import { GET_Countries } from "./services";
import { apiGet, apiGetWithHeader } from "./services/service";
import { toast } from "react-toastify";

export const onSearchDropDown = (allitems: any, value: any) => {
  const filteredOptions = allitems.filter((item: any) =>
    item.label.toLowerCase().includes(value.toLowerCase())
  );
  return filteredOptions;
};

export const getCountry = async () => {
  try {
    const res = await apiGet(GET_Countries);
    if (res.data && res.data.CountryList.length > 1) {

      const Contryotn = JSON.parse(res.data.CountryList).map(
        (items: any, index: any) => {
          return { value: items.Key, label: items.Value };
        }
      );

      const codeObj = JSON.parse(res.data.CountryList).map(
        (items: any, index: any) => {
          return {
            value: items.Key,
            label: `${items.CountryCode} ${items.ShortCode}`,
          };
        }
      );

      let countryCodeResponse = { country: Contryotn, code: codeObj }
      return countryCodeResponse
    }

  } catch (error) {
    console.log(error, "CountryCodeerror")
  }

}


export const allOptionForDropdown = (data: any) => {
  return data
    ? data.map(
      ({ Value, Key }: any) => ({
        label: Value,
        value: Key,
      })
    )
    : [];
}

export const getFieldError = (errors: Record<string, string[] | string | boolean>, fieldName: string) => {
  const errorValue = errors[fieldName];

  const errorArray = Array.isArray(errorValue) ? errorValue : errorValue ? [errorValue] : [];

  return {
    error: errorArray.some((error) => typeof error === "string" && error.trim() !== ''),
    helperText: errorArray.length > 0 ? errorArray[0] : "",
  };
};
export const scrollToErrorField = (fieldName: any)=>{
  setTimeout(()=>{
    const errorField = document.querySelectorAll("TextArea,Input,TextBox,Select");
      for(const fieldName of errorField){
        const element = fieldName as HTMLElement;
        const hasError = element.getAttribute("aria-invalid") === "true" || element.closest(".has-error")
        if(hasError){
          const rect = element.getBoundingClientRect();
          const isInView = rect.top>= 0 && rect.bottom <= window.innerHeight;
          if(!isInView){
            element.scrollIntoView({behavior:"smooth",block:"center"})
          }
          if(typeof element.focus === "function"){
            element.focus();
          }
          break;
        }
      }
    
    // }
  },100)
}
export const validateFields = (name: string, value: string | boolean, requiredFields: any, t:any): string | null => {

  let error = null;
  if (!requiredFields.includes(name)) {
    return error;
  }


  if (!value) {
    error = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
  } 
  
  // else if (name === "FirstName" && value && !validateName(value)) {
  //   error = "Invalid First Name";
  // } else if (name === "LastName" && value && !validateName(value)) {
  //   error = "Invalid Last Name";
  // } 
  // 
  else if (name === "Email" && typeof value === "string" && value && !isValidEmail(value)) {
    error = t('HPI.ErrorMessage.InvalidEmailFormat',{defaultValue:'Invalid email format'});
  } 

  else if ((name === "PhoneNumber" || name === "AlternatePhoneNumber") && !isValidPhoneNumber(value)) {
    error = t('HPI.ErrorMessage.InvalidNumber',{defaultValue:'Phone number must be 8-15 digits long and contain only numbers.'});
  }
  return error;
};

export const onChangeValidateFieldCaseAddress = (name: string, value: string, setErrorState: (prevState: any) => void) => {
  let error = "";

  if (!value) {
    error = "This field is required.";
  }
  if (name === "FirstName" && value && !validateName(value)) {
    error = "Invalid First Name";
  }

  if (name === "LastName" && value && !validateName(value)) {
    error = "Invalid Last Name";
  }
  if (name === "Email" && value && !isValidEmail(value)) {
    error = "Invalid email format.";
  }

  if (name === "PhoneNumber" && !isValidPhoneNumber(value)) {
    error = "Phone number must be 8-15 digits long and contain only numbers..";
  }

  if (name === "City" && !isValidCityName(value)) {
    error = "Please add a valid city name.";
  }

  if (name === "State" && !isValidStateName(value)) {
    error = "Please add a valid state name";
  }

  if (name === 'company' && !isValidCompanyName) {
    error = "Please add a valid company name";
  }

  if ((name === 'AddressLine1' || name === 'AddressLine2') && !isValidAddress(value)) {
    error = "Please add a valid Address";
  }

  // return error
  setErrorState((prevState: any) => ({
    ...prevState,
    [name]: error,
  }));

  // setTimeout(() => {
  //   const fieldElement = document.querySelector(`[name="${name}"]`);
  //   if (fieldElement) {
  //     if (error) {
  //       fieldElement.classList.add("error-field");
  //     } else {
  //       fieldElement.classList.remove("error-field");
  //     }
  //   }
  // }, 50);

};


export const isValidPhoneNumber = (value: any): boolean => {
  return (typeof value === "string" || typeof value === "number") && /^\d{8,15}$/.test(String(value));
};

export const isValidEmail = (value: any): boolean => {
  return  /.+/.test(String(value));
  
};

export const validateName = (name: any) => {
  const regex = /^[\p{L}\s]+$/u;
  return typeof name === "string" && regex.test(name);
};

export const isContainsLettersNumbersSpaces = (str: any): boolean => {
  return typeof str === 'string' && /^[a-zA-Z0-9-]*$/.test(str);
};

export const isContainsLettersNumbersSpacesCaseTitle = (str: any): boolean => {
  return typeof str === 'string' && /^[a-zA-Z0-9 ]*$/.test(str);
};

export const IsAlphabeticCharactersSpacesHyphen = (name: any) => {
  const regex = /^[A-Za-z0-9\s- ]+$/;
  return typeof name === "string" && regex.test(name);
};

export const isValidCompanyName = (name:any) => {
  const regex = /^(?!NA$)(?!N\/A$)[A-Za-z0-9 &,\-#/_]+$/;
  return regex.test(name);
};

export const isValidCityName = (city: any) => {
  return cityRegex.test(city);
};

export const isValidStateName = (state:any) => {
  const regex = /^(?!NA$)(?!N\/A$)[A-Za-z\s\-]+$/;
  return regex.test(state);
};

export const isValidAddress = (name: any) => {
  return addressRegex.test(name);
};

export const addressRegex = /^[a-zA-Z0-9 \-&,#/_]+$/;
export const cityRegex = /^(?!NA$)(?!N\/A$)[A-Za-z\s\-]+$/;

export const validateAddress = async (id: any) => {
  try {
    const response: any = await apiGetWithHeader(GET_TERADICI_PRODUCT_ID);
    console.log(id, 'idddddd productID');
    console.log(response.data.productID, 'response.data.productID')
    return id === response.data.productID
  } catch (error) {
    console.error("Error", error);
    toast.error(`${error}`);
  }
}

export const handleErrorResponse = (error: any) => {
  if (error?.status === 404) {
    const msg = "404 Not Found: The requested resource was not found.";
    toast.error(msg);
    console.error(msg);
  } else if (error?.request) {
    const msg = "No response received from the server.";
    toast.error(msg);
    console.error(msg);
  } else {
    const msg = `Error: ${error?.message || "Unknown error occurred."}`;
    toast.error(msg);
    console.error(msg, error?.data || "");
  }

};

export const getValidatedNumberInput = (input: any, maxLength: number = 5): string => {
  return String(input).match(new RegExp(`^\\d{0,${maxLength}}`))?.[0] || '';
};

export const isValidField = (value: any): boolean => {
  return (typeof value === "string" || typeof value === "number") && !value;
};

export const IndividualRole = (window as any).IsIndividualRole;
export const AdminRole = (window as any).IsAdmin || (window.location.hostname.includes("localhost")) ? true : false;
export const AdminNotIndividualRole = AdminRole && !(window as any).IsIndividualRole;
export const isPolyAgent = (window as any).IsPolyAgent;
export const ExportMaping = (fieldMap:Record<string, string>,data:any) =>{
  // Check if data is null or empty
  if (!data || !Array.isArray(data) || data.length === 0) {
    return [];
  }
  // Check if fieldMap is empty
  if (Object.keys(fieldMap).length === 0) {   
    console.warn("Field map is empty, returning empty array.");
    return [];
  }

  return data.map((item: any) => {
    const record: Record<string, any> = {};
        // Dynamically map fields
        for (const [label, key] of Object.entries(fieldMap)) {
          record[label] = item[key as keyof typeof item] || "";
        }
        // Conditionally add bulk upload
        if (AdminNotIndividualRole) {
          record["Bulk Id"] = item.hpi_bulkid || "";
        }

        return record;
    });
}
export const newToOladSorting= (lists:any,fiels:string)=> {
   const sortedList =lists.sort((a: any, b: any) => {
          const dateA = new Date(a[fiels]).getTime();
          const dateB = new Date(b[fiels]).getTime();if (isNaN(dateA)) return 1;
          if (isNaN(dateB)) return -1;
          return dateB - dateA;
        })
    return sortedList;
}